export default {
  tooltip: {
    fontSize: 12,
  },
}
